import DocumentUploadedSrc from '../../../images/icon-document-uploaded.svg';
import DocumentUploadingSrc from '../../../images/icon-document-uploading.svg';
import { Box } from '../box/box';

const Image = (props: { src: string; alt: string }) => (
  <Box rounded background="neutral100" padding="baseNeg7">
    <img {...props} />
  </Box>
);

export const DocumentUploaded = () => (
  <Image src={DocumentUploadedSrc} alt="" />
);

export const DocumentUploading = () => (
  <Image src={DocumentUploadingSrc} alt="" />
);
